<template>
  <el-table
    :data="tableList"
    border
    :style="{
      width: width,
    }"
    :height="height"
    v-bind="attr"
    ref="thatRef"
  >
    <el-table-column type="selection" v-if="checkbox" />

    <el-table-column
      v-for="(item, index) in tableProps"
      :key="index"
      :fixed="item.fixed"
      :sortable="item.sortable"
      :prop="item.prop"
      :label="item.label"
      :width="item.width"
    >
      <template v-if="item.label == '序号'" #default="scope">
        {{ item.fun(scope.$index + 1) }}
      </template>
      
      <template v-else-if="item.buttonList" #default="scope">

        <el-popover
          placement="left"
          width="max-content"
          trigger="click"
          popper-class="elTable-button-popover"
          :teleported="false"
        >
          <ButtonList :list="item.buttonList" :target="scope.row"/>
          <template #reference>
            <el-button 
              size="small"
              type="primary"
            >操作</el-button>
          </template>
        </el-popover>
      </template>

      <template v-else #default="scope">

      <el-tooltip
        :content="
          (!item.fun
            ?cellInfo(scope.row[item.prop])
            :item.fun(scope.row)) + ''
        "
        popper-class="table-tooltip-container"
        placement="top"
      >
        <div
          class="content-div"
          :class="{
            'copy-div': item.icon == 'copy'
          }"
        >
          {{
            !item.fun
              ?cellInfo(scope.row[item.prop])
              :item.fun(scope.row)
          }}
          <span @click="copyBtn(scope.row[item.prop])">
            <svg-icon
              iconName="el-CopyDocument"
              v-if="item.icon == 'copy'"
              class="el-icon--right copy-svg"
            >
            </svg-icon>
          </span>
        </div>
      </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, useAttrs,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import ButtonList from '@/components/ButtonList/index';
// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});
// props
const props = defineProps({
  width: { type: String, default: ()=>{ return '100%' } },
  height: { type: String, default: ()=>{ return '100%' } },
  tableList: { type: Array, default: ()=>{ return [] } },
  tableProps: { type: Array, default: ()=>{ return [] } },
  checkbox: { type: Boolean, default: ()=> false },
});
// emit
const emit = defineEmits([]);

const attr = useAttrs();

const cellInfo = (val) => {
  if (isNull(val)) {
    return '';
  }
  if (Array.isArray(val)) {
    return val.join(', '); // 如果是数组，使用逗号分隔
  }
  return val; // 如果不是数组，直接返回原值
}

const copyBtn = (val)=>{
  if(navigator && navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(val);
  }else{
    const save = function(e) {
      e.clipboardData.setData('text/plain', val)
      e.preventDefault() // 阻止默认行为
    }
    document.addEventListener('copy', save) // 添加一个copy事件
    document.execCommand('copy') // 执行copy方法
  }
  
  message('复制成功', 1);
}

const thatRef = ref();
defineExpose({
  thatRef,
})

</script>

<style lang='less'>
.table-tooltip-container{
  color: var(--fontColor_2) !important;
}
.elTable-button-popover{
  min-width: auto !important;
}
</style>

<style lang='less' scoped>
:deep(.copy-svg){
  position: absolute;
  right: 2px;
  top: 0.5rem;
}
</style>